angular.module("notifications")

    .controller('NotificationsListCtrl', ['entity_type', '$stateParams', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', 'notificationService', '$filter', 'LoginService', '$state', '$uibModal', 'logService',
        function (entity_type, $stateParams, $rootScope, $scope, Restangular, gridService, modalService, notificationService, $filter, LoginService, $state, $uibModal, logService) {

            $scope.mailings = [];
            $scope.show_title = (entity_type != "correspondence");
            let eventId = null;
            let event: any = null;
            let mailing_id = null;

            $scope.selectStates = [{ id: 'pending', title: $filter('translate')('notifications.sending') },
                { id: 'error', title: $filter('translate')('notifications.sent_error') },
                { id: 'sent', title: $filter('translate')('notifications.sent') }
            ]

            if (typeof ($stateParams.id) !== 'undefined') {
                eventId = $stateParams.id;
                mailing_id = $stateParams.mailing_id;
                if (entity_type == "events") {
                    Restangular.one('Events', $stateParams.id).get().then(function (results) {
                        event = results;
                    });
                }
            } else {
                mailing_id = null;
            }
         
            $rootScope.title = $filter('translate')('notifications.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('notifications.list') }
            ];

            Restangular.all('Mailings').getList({ entity_type_id: $stateParams.id, entity_type: "events" }).then(function (templates) {
                $scope.mailings = templates;
            })

            $scope.search = {
                subject: "",
                mailing_id:"",
                date_from: null,
                date_to: null,
                name: null,
                surname: null,
                lastname: null,
                email: null,
                state: null
            };

            $scope.search.mailing_id = mailing_id;
       
            $scope.gridOptionNotifications = {
                pdfTitle: $filter('translate')('notifications.pdf_title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                paginationPageSizes: [10, 20, 30],
                paginationPageSize: 10,
                enableFiltering: false,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    {
                        name: 'date', displayName: $filter('translate')('notifications.date'), maxWidth: 125, minWidth: 80,
                        type: 'date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'',
                        customFormatFn: function (value) {
                            if (value !== null) {
                                var fecha = new Date(value);
                                return $filter('date')(fecha, 'dd/MM/yyyy');
                            }
                            return "";
                        }   ,                
                        enableFiltering: false, enableColumnMenu: false
                    },
                    {
                        name: 'FK_notifications_emails_events.name',
                        displayName: $filter('translate')('notifications.event'), enableFiltering: false, enableHiding: false, enableColumnMenu: false, minWidth: 100, maxWidth: 250,
                        visible: (eventId != null ? false : true)
                    },
                    { name: 'subject', displayName: $filter('translate')('notifications.subject'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                    {
                        name: 'guests', displayName: $filter('translate')('notifications.info'), enableFiltering: true, enableHiding: false, enableColumnMenu: false, minWidth: 100, maxWidth: 125,
                        cellTemplate: '<div class="ui-grid-cell-contents"><div class="col-sm-1" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" uib-popover="' + $filter('translate')('notifications.sent') + '">' +
                            '<span class= "label label-meddium label-primary">{{row.entity.status_sent}}</span></div><div class="col-sm-1" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" uib-popover="' + $filter('translate')('notifications.sending') + '">' +
                            '<span class="label label-meddium label-default">{{row.entity.status_sending}}</span></div><div class="col-sm-1" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" uib-popover="' + $filter('translate')('notifications.sent_error') + '">' +
                            '<span class="label label-meddium label-danger">{{ row.entity.status_error }}</span></div></div >',
                        visible: ($rootScope.sizeSm || $rootScope.sizeXs ? false : true)
                    },
                    {
                        name: 'scheduled_date', displayName: $filter('translate')('notifications.scheduled_date'), minWidth: 100, maxWidth: 150, enableSorting: false,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{ row.entity.FK_notifications_to_notifications_emails[0].scheduled_date | toLocalDate | date: "dd/MM/yyyy HH:mm" }}</div>',
                        enableFiltering: true, enableHiding: false, enableColumnMenu: false
                    },
                    {
                        name: 'marked_as_invitation_or_program', displayName: '', minWidth: 50, maxWidth: 100,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope "> <span class="label label-meddium label-default" ng-if="row.entity.entity_type==\'accreditation_staff\'">STAFF</span>' +
                            '<span class= "label label-meddium label-default" ng-if= "row.entity.mark_as_sent_invitation" > {{\'notifications.is_invitation\' | translate | uppercase}} </span>' +
                            '<span class="label label-meddium label-info" ng-if="row.entity.entity_type == \'program\'">{{ \'events.programs_acts.programs_acts\' | translate | uppercase}} </span></div>',
                        enableFiltering: true, enableHiding: false, enableColumnMenu: false
                    },
                    {
                        name: ' ', width: 40, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('notifications.button_view'), action: 'ng-click="grid.appScope.goToEdit(row.entity)"', cssIconClass: "fa fa-eye" },
                            // { title: $filter('translate')('notifications.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.subject);"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {

                    options.mailing_id = $scope.search.mailing_id;
                    options.subject = $scope.search.subject;
                    options.date_from = $scope.search.date_from;
                    options.date_to = $scope.search.date_to;
                    options.name = $scope.search.name;
                    options.surname = $scope.search.surname;
                    options.lastname = $scope.search.lastname;
                    options.email = $scope.search.email;
                    options.state = $scope.search.state;

                    if (eventId != null) options.event_id = eventId;
                    if (entity_type != null) options.entity_type = entity_type;

                    return Restangular.all('NotificationsEmails').getList(options)

                }
            
            };

            $scope.searchNotifications = function () {
                if (angular.isDefined($scope.gridOptionNotifications.loadData)) {
                    $scope.gridOptionNotifications.loadData(false);
                }
            }

            $scope.clearSearch = function () {
                $scope.search.mailing_id = null;
                $scope.search.subject = null;
                $scope.search.date_from = null;
                $scope.search.date_to = null;
                $scope.search.name = null;
                $scope.search.surname = null;
                $scope.search.lastname = null;
                $scope.search.email = null;
                $scope.search.state = null;
                $scope.gridOptionNotifications.loadData(false);
            }

            $scope.goToEdit = function (rowEntity) {
                if (eventId != null && entity_type == 'events') {
                    $state.go("events.edit.notifications.edit", { id: eventId, notificationId: rowEntity.id });
                } else {
                    $state.go("notifications.edit", { notificationId: rowEntity.id });
                }
            }


            $scope.send_notification = function () {
                let params = {
                    entity_type: entity_type,
                    entity_type_id: eventId,
                    mail_account_id: (event != null && typeof (event) !== "undefined" ? event.mail_account_id : null),
                    mail_account_reply: (event != null && typeof (event) !== "undefined" ? event.reply_to : null)
                };
                logService.debug("Param a pelo: events: "+ params);
                notificationService.notificationMail({
                    params: params,
                    onAccept: function (data) {
                        toastr.success($filter('translate')('notifications.sending_mail_success'));
                        $scope.gridOptionNotifications.loadData(false);
                    }
                });               
            }

            $scope.deleteDialog = function (id,name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('notifications.button_delete'),
                    message: $filter('translate')('notifications.delete_message')+" "+ + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('NotificationsEmails', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('notifications.delete_success'));
                            $scope.gridOptionNotifications.gridApi.core.raise.itemDeleted($scope);
                        
                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });

            };


    }])

;